import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import VintedPriceTracker from './pages/VintedPriceTracker';
import { CreateAlertPage } from './pages/CreateAlertPage';
import { EditAlertPage } from './pages/EditAlertPage';
import CGU from './pages/CGU';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogArticleGrossistesVinted from './pages/BlogArticleGrossistesVinted';
import BlogArticleBoostVinted from './pages/BlogArticleBoostVinted';
import BlogArticleBotsVinted from './pages/BlogArticleBotsVinted';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<VintedPriceTracker />} />
          <Route path="/alert/new" element={<CreateAlertPage />} />
          <Route path="/alert/edit/:id" element={<EditAlertPage />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/confidentialite" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/grossistes-fournisseurs-vinted" element={<BlogArticleGrossistesVinted />} />
          <Route path="/blog/boost-vinted-utile-ou-mythe" element={<BlogArticleBoostVinted />} />
          <Route path="/blog/bots-vinted-autobuy-autocop" element={<BlogArticleBotsVinted />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
